import BaseScreen from './_base';

export default function SignupScreen() {
  return <BaseScreen title="Signup" description="Plan selection and signup flow." />;
}
